import { FormFieldTypes } from "../../../data/formFieldType";
import ProductList from "../components/ProductList";

export const CompanyInformationData = {
  name: "Company Information",
  initialState: {
    CompanyName: "",
    CompanyUEN: "",
    TypeOfCompany: null,
    MainContactPerson: null,
    MainContactPhone: '',
    MainContactEmailAddress: '',
    ServiceCategory: null,
  },

  formFields: [
    {
      id: "CompanyName",
      lable: "Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "CompanyName",

      fieldSetting: {
        placeholder: "Enter Company Name",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "CompanyUEN",
      lable: "Company UEN",
      Field_Name: "Company UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "CompanyUNE",

      fieldSetting: {
        placeholder: "Enter Company UEN",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },



    {
      id: "TypeOfCompany",
      lable: "Type of Company",
      Field_Name: "Type of Company",
      fieldType: FormFieldTypes.SELECT,
      dataField: "TypeOfCompany",

      fieldSetting: {
        placeholder: "Type of Company",

      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ApplicationInformation",
      lable: "",
      Field_Name: "Application Information",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ApplicationInformation",
      fieldSetting: {
        formTitle: "Application Information",
      },
      style: {
        containerCss: "custom-grid",
      },
    },

    {
      id: "MainContactPerson",
      lable: "Main Contact Person",
      Field_Name: "Main Contact Person",
      fieldType: FormFieldTypes.SELECT,
      dataField: "MainContactPerson",

      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "MainContactPhone",
      lable: "Main Contact Phone",
      Field_Name: "Main Contact Phone",
      fieldType: FormFieldTypes.INPUT,
      dataField: "MainContactPhone",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "MainContactEmailAddress",
      lable: "Main Contact Email Address",
      Field_Name: "Main Contact Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "MainContactEmailAddress",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ServiceDetails",
      lable: "",
      Field_Name: "Service Details",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ServiceDetails",
      fieldSetting: {
        formTitle: "Service Details",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "serviceCategory",
      lable: "Service Category",
      Field_Name: "ServiceCategory",
      fieldType: FormFieldTypes.SELECT,

      dataField: "ServiceCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

  ],

  formSetting: {
    isViewOnly: false,
  },
};

export const AuditlogData = {
  name: "AdditionalInfo",
  initialState: {
    searchByDescription: null,
    dateRange: null,
    updatedBy: null,
  },
  formFields: [
    {
      id: "searchByDescription",
      lable: "Search by Description",
      Field_Name: "Search by Description",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchByDescription",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-10 mb-3 pr-0",
      },
    },

    {
      id: "dateRange",
      lable: "Date Range",
      Field_Name: "Date Range",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "dateRange",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-3 mb-3",
      },
    },
    {
      id: "to",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "to",
      fieldSetting: {
        formTitle: "to",
      },
      style: {
        containerCss: "date-range-to",
      },
    },
    {
      id: "submittedTo",
      lable: "Submitted To",
      Field_Name: "Submitted To",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedTo",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-3 mb-3 hide-title",
      },
    },
    {
      id: "updatedBy",
      lable: "Updated By",
      Field_Name: "Updated By",
      fieldType: FormFieldTypes.SELECT,
      dataField: "updatedBy",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
